import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import 'normalize.css';
import 'picturefill';
import 'es6-promise/auto';
import 'babel-polyfill';
import 'intersection-observer';

import App from 'rebook/mybook/App';
import configureStore from 'rebook/mybook/store';
import 'rebook/apps/base/style/fonts.scss';
import 'rebook/apps/base/style/global.scss';
import 'rebook/apps/base/style/grid.scss';


const BrowserApp = () => (
  // App and RoutedApp are separate components because we need the former in the tests and ssr
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

const store = configureStore();

ReactDOM.hydrate(
  <Provider store={store}>
    <BrowserApp />
  </Provider>,
  document.getElementById('app')
);
